import { Component, Host, h, Element, Prop, Watch } from '@stencil/core';
import { isIe } from '../../../common/_helpers/browsers';
import { RevealAnimationStates } from '../_types/animations';
import { getChildComponent } from '../_helpers/prefixes';

@Component({
	tag: 'ds-page-card',
})
export class DsPageCard {
	isIE = isIe();
	@Element() el;
	@Prop() revealAnimation: RevealAnimationStates = 'on';
	@Prop() animateHover = !this.isIE;
	@Prop() index: number;

	componentDidLoad(): void {
		if (!this.isIE) {
			this.setHoverAnimation();
		}
	}

	@Watch('animateHover')
	onAnimateHoverChange(newState: boolean, prevState: boolean) {
		if (newState !== prevState && !this.isIE) {
			this.setHoverAnimation();
		}
	}

	setHoverAnimation() {
		const animationClass = 'ds-animate-hover';
		const cardEl = getChildComponent(this.el, 'ds-card');
		if (cardEl) {
			if (this.animateHover) {
				cardEl.classList.add(animationClass);
			} else {
				cardEl.classList.remove(animationClass);
			}
		}
	}

	render() {
		return (
			<Host
				class={{
					'ds-animate-reveal': !this.isIE,
					[`ds-animate-reveal--delay-${
						this.index + 1 > 12 ? 12 * 20 : this.index * 20
					}`]:
						!this.isIE &&
						this.revealAnimation === 'delayed' &&
						typeof this.index === 'number' &&
						this.index > 0,
				}}
			>
				<slot></slot>
			</Host>
		);
	}
}
